import { LineItemBuilder } from "./LineItemUpdate";
import { type LineItem } from "~/features/cart/cart/models/CartData";
import type { RootState } from "~/app/store";
import dayjs from "dayjs";
import { getNextUID } from "~/common/utils/uid";

export function isFromContract(lineItem: LineItemBuilder) {
  return !!lineItem.get("contractNumber");
}

export type LineItemMessage = {
  type: "info" | "error" | "fatal";
  key: string;
  params?: Dict<string>;
};

export function sameDate(dateA?: Date | null, dateB?: Date | null) {
  if (dateA === dateB) {
    return true;
  }
  if (!dateA || !dateB) {
    return false;
  }
  return dayjs(dateA).isSame(dateB, "day");
}

export function newChangeObject(lineItem: LineItem): LineItemBuilder {
  return new LineItemBuilder(lineItem, lineItem.productCode);
}

export function newCopyRowObject(lineItem: LineItem): LineItemBuilder {
  const item = new LineItemBuilder(lineItem, lineItem.productCode);
  item.set("entryNumber", lineItem.entryNumber !== null ? lineItem.entryNumber + 1 : null);
  item.set("pk", -getNextUID());
  return item;
}

// TODO: try to remove this function altogether
export function newUpdatesObject(lineItem: LineItem, updates: Partial<LineItem>): LineItemBuilder {
  const item = new LineItemBuilder(lineItem, lineItem.productCode);
  applyUpdates(item, updates);
  return item;
}

const allowUndefinedKeys = new Set<keyof LineItem>(["targetPrice"]);
// TODO: try to remove this function altogether
export function applyUpdates(item: LineItemBuilder, updates: Partial<LineItem>): void {
  Object.entries(updates).forEach(([key, val]) => {
    if (val !== undefined || allowUndefinedKeys.has(key as keyof LineItem)) {
      // @ts-ignore
      item.set(key, val);
    }
  });
}

export function buildCartMaterialNos(state: RootState): Set<string> {
  const entries = Object.values(state.cart.packageEntriesById);
  return new Set(
    entries
      .map((entry) => {
        const product = state.products.basic[entry.productCode];
        return product ? product.sapMaterialNumber + entry.packCode : null;
      })
      .filter((v): v is string => v !== null),
  );
}

export function buildCartMaterialNosExcluding(state: RootState, excludePks: Set<number>): Set<string> {
  const entries = Object.values(state.cart.packageEntriesById);
  return new Set(
    entries
      .filter((entry) => !excludePks.has(entry.pk))
      .map((entry) => {
        const product = state.products.basic[entry.productCode];
        return product ? product.sapMaterialNumber + entry.packCode : null;
      })
      .filter((v): v is string => v !== null),
  );
}
